import { Directive } from '@angular/core';
import { RangeValueAccessor } from '@angular/forms';

// This is needed to get a RangeValueAccessor without the need for formControlName, formControl or ngModel
@Directive({
  selector: '[kbRangeValueAccessor]',
  standalone: true,
})
export class RangeValueAccessorDirective extends RangeValueAccessor {

}
